import styled from 'styled-components';
import MaskedInput from '../../../CommonComponents/MaskedInput';
import Input from '../../../CommonComponents/Input';
import Form from '../../../CommonComponents/Form';
import { StyledButton as Button } from '../../../CommonComponents/Button';

export const Wrapper = styled.div``;

export const Body = styled.div`
  padding: 75px;

  ${Form.Control}:last-child {
    margin-bottom: 0;
  }
`;

export const Footer = styled.div`
  border-top: 1px solid rgba(151, 151, 151, 0.39);
  padding: 15px 25px;
  text-align: right;

  ${Button} + ${Button} {
    margin-left: 10px;
  }
`;

export const Title = styled.span`
  font-size: 24px;
  letter-spacing: -0.7px;
  color: #444444;
  margin-bottom: 30px;
  display: block;
`;

export const StyledInput = styled(Input)`
  ${Input.StyledInput} {
    color: #444444;
    letter-spacing: -0.4px;
  }
`;

export const StyledCurrencyInput = styled(MaskedInput.CurrencyWithSymbol)`
  ${Input.StyledInput} {
    color: #444444;
    letter-spacing: -0.4px;
  }
`;

export const BlockInput = styled(StyledInput)`
  width: 100%;
`;

export const WideButtonPrimary = styled(Button.Primary)`
  width: 170px;
`;

export const WideButtonLink = styled(Button.Link)`
  width: 170px;
`;

export const BackButton = styled(Button.Link).attrs({
  prependIcon: 'fa fa-caret-left',
})`
  position: absolute;
  top: 30px;
  left: 30px;
`;
